import { LoaderEvent } from "../events/LoaderEvent";
import { BaseLoader } from "./BaseLoader";

export class XMLLoader extends BaseLoader {
    constructor(src: string, cacheTimestamp?: string, prependURL?: string, id?: string, body?: any) {
        super(src, cacheTimestamp, prependURL, id, body);
    }

    getData(): any {
        return this._request.response;
    }

    protected getResponseType(): string {
        return "text";
    }

    protected onLoaded(event: any) {
        this.dispatchEvent(new LoaderEvent(LoaderEvent.COMPLETE, this._request.response));
    }

    protected onError(event: any) {
        this.dispatchEvent(new LoaderEvent(LoaderEvent.ERROR));
    }
}
